import cn from "classnames";
import { useTranslation } from "react-i18next";

import { AiLessonReplayToolCall } from "../../aiAgents.types";
import { replayToolMode } from "../../helpers/replay";

import styles from "./ReplayToolTrace.module.scss";

interface Props {
  tool: AiLessonReplayToolCall;
}

// One tool call of a replayed run, collapsed: name, how the replay handled it
// (real data, simulated, handover) and an error badge; input and result when
// opened. Same markup and styles as the Sandbox trace (Sandbox.tsx), which is
// left as it is.
const ReplayToolTrace = ({ tool }: Props) => {
  const { t } = useTranslation();
  const mode = replayToolMode(tool.mode);

  return (
    <details className={styles.tool}>
      <summary className={styles.toolSummary}>
        <span className={styles.toolName}>{tool.toolName}</span>
        <span className={cn(styles.toolBadge, styles[`badge_${mode}`])}>
          {t(`aiReplay.mode.${mode}`)}
        </span>
        {tool.isError && (
          <span className={styles.toolErr}>{t("aiTurn.trace.error")}</span>
        )}
      </summary>
      <div className={styles.toolBody}>
        {tool.note && <div className={styles.toolNote}>{tool.note}</div>}
        <div className={styles.toolLabel}>{t("aiTurn.trace.input")}</div>
        <pre className={styles.toolPre}>
          {JSON.stringify(tool.input ?? {}, null, 2)}
        </pre>
        <div className={styles.toolLabel}>{t("aiTurn.trace.result")}</div>
        <pre className={styles.toolPre}>{tool.resultPreview}</pre>
      </div>
    </details>
  );
};

export default ReplayToolTrace;
